export default __webpack_public_path__ + "static/marry-your-daughter-f17b712cd2b3ee8c002e6722ca338b14.mp3";